"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2395],{

/***/ 32395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18132);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const VehicleDetails = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(804), __webpack_require__.e(1521), __webpack_require__.e(7311), __webpack_require__.e(2547), __webpack_require__.e(7119)]).then(__webpack_require__.bind(__webpack_require__, 47119)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(47119)]
  }
});

const VehicleDetailsContainer = ({
  title,
  vehicle
}) => {
  const {
    t
  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)();
  const engineContent = [{
    name: t('vehicleDetailsContainer:engine.fuel'),
    value: vehicle.engine.fuel
  }, {
    name: t('vehicleDetailsContainer:engine.displacement'),
    value: vehicle.engine.displacement
  }, {
    name: t('vehicleDetailsContainer:engine.power'),
    value: vehicle.engine.power
  }, {
    name: t('vehicleDetailsContainer:engine.driveType'),
    value: vehicle.engine.driveType
  }, {
    name: t('vehicleDetailsContainer:engine.transmission'),
    value: vehicle.engine.gear
  }];
  const dimensionsContent = [{
    name: t('vehicleDetailsContainer:dimensions.sizes'),
    value: vehicle.dimensions.sizes
  }, {
    name: t('vehicleDetailsContainer:dimensions.trunk'),
    value: vehicle.dimensions.trunk
  }, {
    name: t('vehicleDetailsContainer:dimensions.seats'),
    value: vehicle.dimensions.seats
  }, {
    name: t('vehicleDetailsContainer:dimensions.doors'),
    value: vehicle.dimensions.doors
  }];
  const consumptionContent = [{
    name: t('vehicleDetailsContainer:consumption.fuel'),
    value: vehicle.consumption.fuel
  }, {
    name: t('vehicleDetailsContainer:consumption.emissions'),
    value: vehicle.consumption.emissions
  }];
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(VehicleDetails, {
    title: title,
    engineTitle: t('vehicleDetailsContainer:engineTitle'),
    engine: engineContent,
    dimensionsTitle: t('vehicleDetailsContainer:dimensionsTitle'),
    dimensions: dimensionsContent,
    consumptionTitle: t('vehicleDetailsContainer:consumptionTitle'),
    consumption: consumptionContent
  });
};

/* harmony default export */ __webpack_exports__["default"] = (VehicleDetailsContainer);

/***/ })

}]);